import config from '~/config';
import MatchMedia from '~/packages/match-media';

class ServiceLocator {

    /**
     * Cached instances
     *
     * @private
     */
    private cached = {};

    /**
     * Media Queries service
     */
    public get matchMedia(): MatchMedia {
        return this.cache('matchMedia', () => {
            return new MatchMedia(config.mediaQueries);
        });
    }

    /**
     * Caches a service instance by creating a singleton
     *
     * @param name
     * @param callable
     * @protected
     */
    protected cache<T>(name: string, callable: (locator: this) => T): T {
        const that = this;
        const cached = that.cached;

        if (cached[name] === undefined) {
            cached[name] = callable(that);
        }

        return cached[name];
    }
}

interface IServiceLocator extends ServiceLocator {
}

export default new ServiceLocator();
export { IServiceLocator };
